import { getAppProps } from '@/AppProps';
import { isIOS } from '@kibt/krn-utils';
import { Dimensions } from 'react-native';

/**
 * @deprecated android使用fixed固底方案，position="fixed" 已经不建议使用，请使用FixedView固底组件
 */
export function useFixedPosition() {
    return 'fixed';
}

/**
 * @deprecated iOS吸底不再推荐krn_bottom_sheet_view_id方案，请使用FixedView固底组件
 */
export function useIosFixedNativeID() {
    const { foldRatio = 1 } = getAppProps();
    const bottom = Dimensions.get('window').height * (1 - foldRatio);

    return {
        nativeID: isIOS ? 'krn_bottom_sheet_view_id' : '',
        bottom: bottom,
    };
}
